import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import HotelTabsContainer from './HotelTabsContainer';

export default Node.create({
  name: 'hotelTabsContainer',

  group: 'block',
  content: 'hotelTabSection+',

  addNodeView() {
    return ReactNodeViewRenderer(HotelTabsContainer);
  },

  parseHTML() {
    return [{ tag: 'div[data-hotel-tabs-container]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-hotel-tabs-container': '' }), 0];
  },
});
